import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_PROJECT_UPDATE:
      return action.listsProject
    default:
      return state
  }
}